import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "../data/content";

const OPTION_MAP = {
  "Logo Design & Branding": "Logo & Branding",
  "Business Support": "Other",
};

export const Services = ({ onEnquire }) => (
  <section id="services" data-testid="services-section" className="noise-overlay relative bg-navy-900 py-24 lg:py-32">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(212,175,55,0.05),transparent_50%)]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading
          overline="What We Do"
          testId="services-heading"
          title={
            <>
              Every service your business needs, <span className="text-gold-metallic italic pr-2 -mr-2">under one roof</span>
            </>
          }
          description="Compliance, digital and growth — delivered by one dedicated team that understands your whole business, not just one slice of it."
        />
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-7">
        {SERVICES.map((service, i) => {
          const Icon = service.icon;
          return (
            <Reveal key={service.id} delay={(i % 4) * 0.08} className="h-full">
              <article
                data-testid={`service-card-${service.id}`}
                className={`card-lift group flex h-full flex-col rounded-3xl border border-white/8 bg-navy-850/80 p-7 ${
                  service.featured ? "sheen-border" : ""
                }`}
              >
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-gold/25 bg-gold/8 p-3 transition-all duration-500 group-hover:bg-gold/15 group-hover:shadow-[0_0_28px_rgba(212,175,55,0.25)]">
                  <Icon className="h-6 w-6 text-gold transition-transform duration-500 group-hover:scale-110" />
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-50">{service.title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-400">{service.tagline}</p>
                <ul className="mt-5 space-y-2">
                  {service.benefits.map((b) => (
                    <li key={b} className="flex items-center gap-2.5 text-xs text-slate-300">
                      <Check className="h-3.5 w-3.5 shrink-0 text-gold" />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`service-enquire-${service.id}`}
                  onClick={() => onEnquire(OPTION_MAP[service.title] || service.title)}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-gold-soft transition-colors duration-300 hover:text-gold-bright"
                >
                  Enquire
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
